import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import cx from 'classnames';
var useStyles = makeStyles(function (theme) {
  return {
    paper: {
      padding: theme.spacing(2.5),
      margin: theme.spacing(1.25),
      borderRadius: 'unset'
    },
    mobileView: {
      display: 'flex',
      flexDirection: 'column',
      columnCount: 'unset'
    },
    view: {
      columnCount: 3,
      columnFill: 'balance'
    }
  };
});
var CustomPaper = function CustomPaper(_ref) {
  var _cx, _cx2;
  var isMobileView = _ref.isMobileView,
    children = _ref.children;
  var classes = useStyles();
  return React.createElement(Paper, {
    classes: {
      root: cx(classes.paper, (_cx = {}, _cx[classes.mobileView] = isMobileView, _cx))
    }
  }, React.createElement(Grid, {
    className: cx(classes.view, (_cx2 = {}, _cx2[classes.mobileView] = isMobileView, _cx2))
  }, children));
};
CustomPaper.propTypes = process.env.NODE_ENV !== "production" ? {
  isMobileView: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
} : {};
export default CustomPaper;